<ng-template #showpopup>
  <div class="modal-header">
    <h5 class="modal-title">Notification</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="autoEnrollInsurance() ">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  @if (AutoEnrollPropertyProtection) {
    <div class="modal-body">
      <p>
        Paying the Property Protection Due will reactivate the property protection scheme that was terminated due to
        non-payment.
      </p>
    </div>
  }
  @if (AutoEnrolExpiredInsWithNoCharge) {
    <div class="modal-body">
      <p>Paying the due resulting in change in PTD will reactivate the Property protection scheme that was terminated due to non-payment</p>
    </div>
  }
  <div class="modal-footer">
    <button class="btn btn-primary" type="button" (click)="autoEnrollInsurance()">Yes</button>
  </div>
</ng-template>

<ng-template #showpopupforpartialPayment>
  <div class="modal-header">
    <h5 class="modal-title">Confirm</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closePartialPaymentPopUp()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Partial payment will remove the property protection which was auto enrolled.</p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-primary me-3" type="button" (click)="ContinueWithEnrolledPP()">No</button>
    <button class="btn btn-primary" type="button" (click)="RemoveAEnrolledPP()">Yes</button>
  </div>
</ng-template>

<ng-template #showpopupforzeroPayment>
  <div class="modal-header">
    <h5 class="modal-title">Confirm</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closePartialPaymentPopUp()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>No payment towards Property Protection will remove the property protection that is auto enrolled.</p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-primary me-3" type="button" (click)="ContinueWithEnrolledPP()">No</button>
    <button class="btn btn-primary" type="button" (click)="RemoveAutoEnrolledPPWithNoDue()">Yes</button>
  </div>
</ng-template>
